module.exports = __webpack_public_path__ + "img/hairsalon4.bd8cdc37.png";